import router from './router'
import store from './store'
import NProgress from 'nprogress' 
import 'nprogress/nprogress.css' 
import {
getToken
} from '@/utils/auth' // 验权
import apiYs from '@/api/getApi'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import Vue from 'vue'
import {
is_weixn,
getWxCode,
getOpenId
} from '@/utils/index'


Vue.use(ConfirmPlugin);


function hasPermission(roles, permissionRoles) {
if (roles.indexOf('admin') >= 0) return true; 
if (!permissionRoles) return true;
return roles.some(role => permissionRoles.indexOf(role) >= 0)
}



router.beforeEach((to, from, next) => {

let origin = to.query.origin || sessionStorage.getItem('origin');
if (origin) {
for (let key in to.query) {
sessionStorage.setItem(key, to.query[key])
}
} else {
NProgress.start(); 
}

var jurisdictionPage = [
'/', //新首页
'/notice', //消息中心
'/ucenter/order/plist/buyer', //订单中心
'/afterSaleList', //售后中心
'/ucenter/account/coupons', //优惠券
'/ucenter/account/address', //地址管理
'/ucenter/account/safety', //账户安全
'/ucenter/agent/user', //会员管理
'/ucenter/order/plist/saler', //出售订单
'/signatory/signatoryHome', //签约管理
'/ucenter/school', //品牌大学
'/ucenter/school/train_apply_list', //报名记录
'/ucenter/account/address', // 地址管理
];

let from_fullPath = from.fullPath; 
let to_fullPath = to.fullPath; 

console.log(to_fullPath)
if (getToken()) {
next() 
} else {
if (jurisdictionPage.includes(
to_fullPath.indexOf('?') > -1 ?
to_fullPath.split('?')[0] : to_fullPath)) {
next('/login') 
} else {
next() 
}
}


let title = 'INGS|英树官网暨网上商城-植物美肌的秘密',
mateKeywords = '英树官网,英树,英树化妆品,英树玻尿酸,INGS',
mateDescription = 'INGS|英树，秉承英国贵族健康、天然护肤的理念，严选来自世界优良产地的安全原料，科学萃取活性护肤成分，提出一“净”、二“修”、三“养”阶段式护肤理念，让肌肤重拾健康屏障';
router.options.routes.forEach(item => {
if (to.path !== '/' && item.path.indexOf(to.path) > -1) {
title = 'INGS|英树官网暨网上商城-植物美肌的秘密';
mateKeywords = '英树官网,英树,英树化妆品,英树玻尿酸,INGS';
mateDescription = 'INGS|英树，秉承英国贵族健康、天然护肤的理念，严选来自世界优良产地的安全原料，科学萃取活性护肤成分，提出一“净”、二“修”、三“养”阶段式护肤理念，让肌肤重拾健康屏障';
let titleMsg = item.title ? item.title : item.meta.title;
if (titleMsg) {
store.title = 'INGS|英树官网暨网上商城-植物美肌的秘密-' + titleMsg;
title += '-' + titleMsg;
mateKeywords += '-' + titleMsg;
mateDescription += '-' + titleMsg;
}
}
});


if (origin) {
title = to.query.title || to.meta.title || '英树';
}

document.getElementsByTagName('title')[0].innerText = title; 
document.getElementsByTagName('meta')['keywords'].content = mateKeywords; 
document.getElementsByTagName('meta')['description'].content = mateDescription; 

/**
*  SEO 解决方案、每个页面不一样的title、keywords、description
* **/

/**
*  判断是否是微信环境、如果是获取微信用户信息
*  ------------  start --------------
* **/



















/**
* 判断是否是微信环境、如果是获取微信用户信息
*  ----------- end ----------
* **/


if (!origin) {
NProgress.done(); 
}
});

router.afterEach((to, from) => {
NProgress.done(); 

window.entryUrl = 'https://wap.inglemirepharms.cn' + to.fullPath;
window.urlPath = to.fullPath;
if (is_weixn()) {
getWxTicket();
}
});

async function getWxTicket() {
const response = await apiYs.javaGet('/common/get_wx_ticket', {
sign_url: window.entryUrl.split("#")[0]
});
if (response.data.code === 0 && response.data.data) {
window.shareData = response.data.data;
wxConfig(response.data.data)
}
}

function wxConfig(param) {
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: param.appId, // 必填，公众号的唯一标识
timestamp: param.timestamp, // 必填，生成签名的时间戳
nonceStr: param.nonceStr, // 必填，生成签名的随机串
signature: param.signature, // 必填，签名
jsApiList: [
"menuItem:share:appMessage", //发送给朋友:
"menuItem:share:timeline", //分享到朋友圈:
"menuItem:share:qq", //分享到QQ:
"menuItem:share:weiboApp", //分享到Weibo:
"menuItem:favorite", //收藏:
"menuItem:share:facebook", //分享到FB:
"menuItem:share:QZone", // 分享到 QQ 空间/
"menuItem:refresh", //刷新:
"menuItem:openWithQQBrowser", // 在QQ浏览器中打开
"menuItem:openWithSafari", //在Safari中打开:
"menuItem:share:email", //邮件
"scanQRCode",
"checkJsApi",
"updateAppMessageShareData",
"updateTimelineShareData",
"onMenuShareWeibo",
"onMenuShareTimeline",
"onMenuShareAppMessage",
"onMenuShareQQ",
"onMenuShareQZone",

] // 必填，需要使用的JS接口列表
});
if (wx) {
wx.ready(function () {
if ((window.urlPath.indexOf('invitationFans') !== -1) || (window.urlPath.indexOf('product/details') !== -1)) {


wx.checkJsApi({ //判断当前客户端版本是否支持指定JS接口
jsApiList: [
'updateAppMessageShareData',
'updateTimelineShareData'
],
success: function (res) { // 以键值对的形式返回，可用true，不可用false。如：{"checkResult":{"scanQRCode":true},"errMsg":"checkJsApi:ok"}


if (res.checkResult.scanQRCode != true) {

} else {

}
},
fail: function (res) { //检测getNetworkType该功能失败时处理
}
});

}


});
wx.error(function (res) {

});
}

}



// WEBPACK FOOTER //
// ./src/permission.js